import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {AuthService} from "../../../../Services/auth.service";

@Component({
  selector: 'app-mda-footer',
  templateUrl: './mda-footer.component.html',
  styleUrls: ['./mda-footer.component.css']
})
export class MdaFooterComponent implements OnInit {

  constructor(private el: ElementRef, public authService:AuthService) { }
  @ViewChild('myFooter') myDiv!: ElementRef;
  ngOnInit(): void {
    setTimeout(() => {
      this.myDiv.nativeElement.style.backgroundColor = this.authService.getPrimaryColor();

      const links = this.el.nativeElement.querySelectorAll('a');
      links.forEach((link: HTMLElement) => {
        link.style.color = this.authService.getPrimaryTextColor();
      });
      const h3 = this.el.nativeElement.querySelectorAll('h3');
      h3.forEach((link: HTMLElement) => {
        link.style.color =  this.authService.getPrimaryTextColor();
      });
      const p = this.el.nativeElement.querySelectorAll('p');
      p.forEach((link: HTMLElement) => {
        link.style.color =  this.authService.getPrimaryTextColor();
      });

    });
  }
}
